/**
 * Extract state or province code from US/Canada addresses
 * 
 * Examples:
 * "New York, NY 10001" -> "NY"
 * "Portland, OR 97201" -> "OR"
 * "Toronto, ON M5H 2N2" -> "ON"
 */
export function extractStateOrProvince(address: string | null | undefined): string | null {
  if (!address) return null;
  
  // Match US format: State code followed by ZIP (e.g., "NY 10001")
  const usPattern = /,\s*([A-Z]{2})\s+\d{5}/;
  
  // Match Canada format: Province code followed by postal code (e.g., "ON M5H 2N2")
  const canadaPattern = /,\s*([A-Z]{2})\s+[A-Z]\d[A-Z]/i;
  
  // Try US pattern first
  let match = address.match(usPattern);
  if (match && match[1]) {
    return match[1];
  }
  
  // Try Canada pattern
  match = address.match(canadaPattern);
  if (match && match[1]) {
    return match[1].toUpperCase();
  }
  
  return null;
}
